<template>
  <el-card shadow="never">
    <template slot="header">
      <span class="el-card__left">我收藏的</span>
    </template>
    <div class="bid-cotnainer">
      <div class="bid-tabs">
        <el-button v-for="(item, index) in tabs" :key="index" :class="{ 'active': item.value === active }" @click="tabChange(index)">{{ item.name }}</el-button>
      </div>
      <div v-loading="isLoading" class="bid-list">
        <template v-if="list.length > 0">
          <bid-item
            v-for="(item, index) in list"
            :key="index"
            :content-length="126"
            :value="item"
            :actions="actions"
            :is-preview="active === 1"
          />

          <el-pagination background layout="prev, pager, next, jumper" :current-page="pagination.current" :page-size="pagination.size" :total="pagination.total" @current-change="pageChange" />
        </template>

        <empty-layout v-else />
      </div>
    </div>
  </el-card>
</template>

<script>
import BidItem from '@/components/BidItem'
import EmptyLayout from '@/components/EmptyLayout'
import { fetchMyCollection, cancelCollectBid, cancelCollectPreview } from '@/api'

const PAGE_SIZE = 3

export default {
  components: {
    BidItem,
    EmptyLayout
  },

  data() {
    return {
      tabs: [
        {
          value: 0,
          name: '招标项目'
        },
        {
          value: 1,
          name: '招标预告'
        }
      ],
      active: 0,

      list: [],

      actions: [
        {
          text: '取消收藏',
          onClick: async value => {
            const params = {
              id: value.id
            }

            try {
              const result = await (this.active === 0 ? cancelCollectBid(params) : cancelCollectPreview(params))

              this.$message.success('取消成功')
              // 刷新当前页数据
              this.fetchCollection(this.pagination.current)
            } catch (error) {
              this.$message.error(error.message)
            }
          }
        }
      ],

      pagination: {
        current: 1,
        size: PAGE_SIZE,
        total: 0
      },

      isLoading: false
    }
  },

  mounted() {
    this.fetchCollection()
  },

  methods: {
    tabChange(index) {
      this.active = this.tabs[index].value
      this.list = []

      this.fetchCollection()
    },

    fetchCollection(page = 1) {
      this.pagination.current = page
      this.isLoading = true

      fetchMyCollection({
        type: this.active,
        pageSize: PAGE_SIZE,
        pageNo: page
      })
        .then(res => {
          const { records = [], total = 0 } = res.data

          this.list = records.map(val => {
            switch (val.collectionType) {
              case 0:
                return val.projectInfo
                break
              case 1:
                return val.newsDo
                break
            }
            return val
          })
          this.pagination.total = total
        })
        .catch(err => {
          this.$message.error(err.message)
        })
        .finally(res => {
          this.isLoading = false
        })
    },

    pageChange(page) {
      document.documentElement.scrollTop = 0
      this.fetchCollection(page)
    }
  }
}
</script>

<style lang="scss" scoped>
.bid-tabs {
  .el-button {
    width: 105px;
    height: 40px;
    line-height: 38px;
    padding: 0;
    font-size: 16px;
    color: #417EF7;
    border-color: currentColor;
  }
  .active {
    color: #fff;
    background-color: #417EF7;
  }
}
.bid-list {
  margin: 30px 0 0;
  .el-pagination {
    display: table;
    margin: 20px auto 0;
  }
}
</style>
